'use client';

import { useEffect } from 'react';

export default function FxVerifyWidget() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://fxverify.com/Content/remote/remote-widgets.js';
    script.onload = () => {
      if (typeof window.RemoteCalc === 'function') {
        window.RemoteCalc({
          Url: 'https://fxverify.com',
          Calculator: 'reviews',
          DefaultThemeMode: 'dark',
          Width: '100',
          WidgetProperties: {
            WidgetType: 'vertical',
            RatingType: 'user-rating',
            LinkUrl: 'review',
            Elements: ['your-star-rating', 'transparency-partner-text', 'none'],
            IncludeLink: true,
            BrokerId: 4514,
          },
          ContainerId: 'reviews-842700',
        });
      }
    };
    document.head.appendChild(script);
  }, []);

  return (
    <div className="container !mt-[50px] min-h-[80px] !p-0">
      <div id="reviews-842700"></div>
      {/* <a
        href="https://fxverify.com/prop-firms/4514/DP%20Funded?tab=review"
        target="_blank"
        id="reviews-842700-review-link"
        data-broker-name="DP Funded"
        style={{
          fontSize: '13px',
          fontFamily: "'Open Sans', Arial !important",
          marginTop: '8px !important',
          color: '#0275D8 !important',
          textDecoration: 'none !important',
          display: 'none',
          lineHeight: '130% !important',
        }}
      >
        DP Funded Reviews Verified by FXVerify
      </a> */}
    </div>
  );
}
